'use client'

import { type FC } from 'react'
import { useHits } from 'react-instantsearch'

import { type AlgoliaProxyRecord } from '../../../../algolia'
import {
  ProductSearchResultItem,
  ProductSearchResultItemContextProvider,
} from '../../../../product-search'

export const StoryblokBrandProductSearchResults: FC = () => {
  const { items } = useHits<AlgoliaProxyRecord>()

  return (
    <ul className="grid gap-9">
      {items.map((item) => (
        <li key={item.id}>
          <ProductSearchResultItemContextProvider algoliaRecord={item}>
            <ProductSearchResultItem />
          </ProductSearchResultItemContextProvider>
        </li>
      ))}
    </ul>
  )
}
